import React from 'react';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';
import { useSessionData } from '@confluence/session-data';

import { ChangeEditionPageRestrictionsLegacyCoordinator } from '../PageRestrictionsLegacyCoordinator/ChangeEditionPageRestrictionsLegacyCoordinator';
import { ChangeEditionSectionMessageLegacyCoordinator } from '../SectionMessageLegacyCoordinator/ChangeEditionSectionMessageLegacyCoordinator';

/**
 * @deprecated Please reach out to #cc-virality for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */
export const ChangeEditionLegacyCoordinator = () =>
	useSessionData().edition === 'FREE' ? (
		<>
			<TransparentErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
				<ChangeEditionSectionMessageLegacyCoordinator />
			</TransparentErrorBoundary>
			<TransparentErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
				<ChangeEditionPageRestrictionsLegacyCoordinator />
			</TransparentErrorBoundary>
		</>
	) : null;
